import { render, staticRenderFns } from "./SelectUfSigla.vue?vue&type=template&id=0fd29aac&scoped=true&"
import script from "./SelectUfSigla.vue?vue&type=script&lang=ts&"
export * from "./SelectUfSigla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd29aac",
  null
  
)

export default component.exports